<template>
  <v-sheet
    color="white"
    elevation="5"
    rounded
    v-bind:style="`td { margin: 5px; }`"
  >
      <v-dialog v-model="showDeleteConfirmationDialog" max-width="550px">
        <v-card>
          <v-card-title>
            <h3>Are you sure you want to delete show result?</h3>
          </v-card-title>
          <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="secondary" @click="showDeleteConfirmationDialog = false">
                Cancel
              </v-btn>
              <v-btn color="primary" @click="confirmDelete">
                 Delete
              </v-btn>
             <v-spacer />
           </v-card-actions>
        </v-card>
      </v-dialog>

      <v-alert v-if="!!errorMessage" type="error">
        {{ errorMessage }}
      </v-alert>

      <div class="results-container">
      <table class="results-table">
        <tr class="results-grid-row results-header">
            <th class="dog-column">Dog ID</th>
            <th class="date-column">Date</th>
            <th class="category-column">Class or Division</th>
            <th class="jump-column">Jump #</th>
            <th class="distance-column">Distance</th>
            <th class="judge-column">Judge</th>
            <th class="handler-column">Handler</th>
            <th class="score-column">Score</th>
            <th class="actions-column"></th>
        </tr>
        <tr id="sr-empty" v-if="!!emptyRow" class="results-grid-row orange lighten-4">
                  <td class="dog-column pr-1" :style="`text-align: left;`">
                    <v-text-field
                        id="srEmptyDogId"
                        ref="srEmptyDogId"
                        v-model.trim="emptyRow.dogId"
                      />
                  </td>
                  <td class="date-column pr-1 pl-1">
                    <DatepickerFormatted
                      :disableClearable="true"
                      :date="emptyRow.showDate"
                      :min="showInfo.allowedDatesFrom"
                      :max="showInfo.allowedDatesTo"
                      v-on:updateDates="($event) => updateDates($event, 'showDate', emptyRow)" />
                  </td>
                  <td class="category-column pr-1 pl-1">
                    <v-autocomplete
                      v-model="emptyRow.categoryId"
                      item-value="id"
                      item-text="displayValue"
                      :items="showInfo.categories.filter(c => c.id === 'L' || c.id === 'F')"
                      :rules="[(v) => !!v || 'Required']"
                    />
                  </td>

                  <td class="jump-column pr-1 pl-1">
                    <v-text-field
                      v-model.trim="emptyRow.jumpNo"
                      :rules="jumpNumberRules"
                    />
                  </td>

                  <td class="distance-column pr-1 pl-1">
                    <DistanceInput ref="distance-empty" v-model="emptyRow.distance" required />
                  </td>

                  <td class="judge-column pr-1 pl-1">
                    <v-autocomplete
                      v-model="emptyRow.judgeId"
                      item-value="id"
                      item-text="displayValue"
                      :items="showInfo.judges"
                      :rules="[(v) => !!v || 'Required']"
                    />
                  </td>
                  <td class="handler-column pr-1 pl-1">
                    <v-text-field
                      v-model.trim="emptyRow.dogHandler"
                      :rules="[(v) => !!v || 'Handler is required']"
                    />
                  </td>
                  <td colspan="2" class="entry-actions actions-column pl-1">
                    <div class="action-buttons">
                      <v-icon color="primary" @click="saveShowResult(emptyRow, showResults.length - 1)">
                        mdi-content-save-edit
                      </v-icon>
                    </div>
                  </td>
                </tr>
        </table>
        <v-virtual-scroll
          ref="resultsScroller"
          class="results-scroll"
          :items="showResults"
          :item-height="100"
          :height="resultsHeight"
          content-tag="table"
          id="DockJumpingShowResultsScroller"
          >
          <template v-slot:default="{ item, index }">
            <v-list-item class="pa-0" :key="item.resultId" :id="`sr-${item.resultId}`">
              <v-list-item-content>
                <tr :class="['results-grid-row', row_classes(item, index)]" :id="`sr-row-${item.resultId}`">
                  <td class="dog-column pr-1">
                    <v-text-field
                        v-model.trim="item.dogId"
                      />
                  </td>
                  <td class="date-column pr-1 pl-1">
                    <DatepickerFormatted
                      :disableClearable="true"
                      :date="item.showDate"
                      :min="showInfo.allowedDatesFrom"
                      :max="showInfo.allowedDatesTo"
                      v-on:updateDates="($event) => updateDates($event, 'showDate', item)" />
                  </td>
                  <td class="category-column pr-1 pl-1">
                    <v-autocomplete
                      v-model="item.categoryId"
                      item-value="id"
                      item-text="displayValue"
                      :items="categoryItemsForRow(item)"
                      :rules="[(v) => !!v || 'Required']"
                    />
                  </td>
                  <td class="jump-column pr-1 pl-1">
                    <v-text-field
                      v-model.trim="item.jumpNo"
                      :rules="jumpNumberRules"
                    />
                  </td>
                  <td class="distance-column pr-1 pl-1">
                    <DistanceInput :ref="`distance-${item.resultId}`" v-model="item.distance" required />
                  </td>


                  <td class="judge-column pr-1 pl-1">
                    <v-autocomplete
                      v-model="item.judgeId"
                      item-value="id"
                      item-text="displayValue"
                      :items="showInfo.judges"
                      :rules="[(v) => !!v || 'Required']"
                    />
                  </td>
                  <td class="handler-column pr-1 pl-1">
                    <v-text-field
                      v-model.trim="item.dogHandler"
                    />
                  </td>
                  <td class="score-column pr-1 pl-1">
                    <strong>{{ item.score }}</strong>
                  </td>

                  <td class="actions-column pl-1">
                    <div class="action-buttons">
                      <v-icon color="primary" @click="saveShowResult(item, index)">
                        mdi-content-save-edit
                      </v-icon>
                      <v-icon :disabled="!item.resultId" tabindex="-1" @click="deleteShowResult(item)">
                        mdi-delete
                      </v-icon>
                    </div>
                  </td>
                </tr>
                <tr v-if="item.dogName" :class="row_classes(item, index)">
                  <td colspan="9" class="dog-name-row">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <a
                          class="text--secondary caption"
                          v-bind="attrs"
                          v-on="on"
                          tabindex="-1"
                          :href="`/admin/dogs/${encodeURIComponent(item.dogId)}`"
                          target="_blank"
                        >{{ item.dogName }}</a>
                      </template>
                      <span>{{ item.dogName }}</span>
                    </v-tooltip>
                  </td>
                </tr>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-virtual-scroll>
      </div>

  </v-sheet>
</template>

<script lang="ts">
import Vue from "vue";
import * as _ from "lodash";
import DatepickerFormatted from "../../../common/inputs/DatepickerFormatted.vue";
import DistanceInput from "../../../common/inputs/DistanceInput.vue";
import showService from "@/services/admin/showService";
import { getErrorMessage } from "@/services/errorHandler";

export default Vue.extend({
  name: "DockJumpingShowResultsEntry",
  components: {
    DatepickerFormatted,
    DistanceInput
  },
  data: function() {
    return {
      showDeleteConfirmationDialog: false,
      deletedShowResultId: null,
      showResults: [] as any[],
      persistedShowResults: [] as any[],
      errorMessage: null as any,
      emptyRow: null as any,
      resultsHeight: 680,
      jumpNumberRules: [
        (value: string) => /^[1-9]\d?$/.test(value || "") || "Enter a jump # from 1 to 99",
      ],
    };
  },
  methods: {
    emptyShowResultRow: function(lastPersistedRow: any, showResults: any[]){
      if(!lastPersistedRow){
        if(!!showResults && showResults.length > 0){
          lastPersistedRow = Object.assign({}, showResults[showResults.length - 1]);
        }
      }

      if(!!lastPersistedRow){
        return {
          resultId: null,
          isNewRow: true,
          dogId: null,
          showDate: lastPersistedRow.showDate,
          judgeId: lastPersistedRow.judgeId,
          categoryId: null,
          jumpNo: null,
          distance:null,
          dogHandler: lastPersistedRow.dogHandler,
          score: null,
          showId: this.showId
        };
      } else {
        return {
          resultId: null,
          isNewRow: true,
          dogId: null,
          showDate: this.showInfo.defaultDate,
          categoryId: null,
          jumpNo: null,
          distance: null,
          judgeId: (!!this.showInfo.judges && this.showInfo.judges.length == 1) ? this.showInfo.judges[0].id : null,
          dogHandler: null,
          hit: null,
          score: null,
          showId: this.showId
        };
      }
    },
    reloadData: function() {
      if (this.showId) {
        this.$store.dispatch("changeLoaderStatus",true);

        showService
            .getShowResultsByShowId(this.showId, 'DJ')
            .then((res) => {
                this.showResults = _.cloneDeep(res);
                this.persistedShowResults = _.cloneDeep(res);
                this.emptyRow = Object.assign({}, this.emptyShowResultRow(null, res));
            })
            .catch(this.$handleError)
            .finally(() => {
                this.$store.dispatch("changeLoaderStatus",false);
                this.updateResultsHeight();
            });
      }
    },
    row_classes: function(item: any, index: number){
      if (!!item.resultId)
      {
        const index = this.showResults.findIndex(i => i.resultId === item.resultId);
        if(_.isEqual(this.showResults[index], this.persistedShowResults[index])){
          return '';
        }
      }
      return 'orange  lighten-4';
    },
    saveShowResult: function(item: any, index: any) {
      const distanceRef = this.$refs[`distance-${item.resultId ?? "empty"}`] as
        | (Vue & { validate: () => boolean })
        | Array<Vue & { validate: () => boolean }>;
      const distanceInput = Array.isArray(distanceRef) ? distanceRef[0] : distanceRef;
      if (!distanceInput?.validate()) return;
      if (!/^[1-9]\d?$/.test(item.jumpNo || "")) {
        this.errorMessage = "Enter a jump # from 1 to 99";
        return;
      }

      this.$store.dispatch("changeLoaderStatus",true);
      this.errorMessage = null;
      const isAddingNewRow = !item.resultId;
      showService.updateShowResult(this.showId, 'DJ', item)
        .then((res) => {
          if(!res.success){
            this.errorMessage = getErrorMessage({ data: res });
            if(isAddingNewRow){
              const input = document.querySelector('#srEmptyDogId') as HTMLElement | null;

              if (input != null) {
                  input.focus();
              }
            }
          } else {
            if(isAddingNewRow){
              this.emptyRow.resultId = res.id;
              this.emptyRow.dogName = res.dogName;
              this.emptyRow.dogCallName = res.dogCallName;
              this.showResults.unshift(this.emptyRow);
              this.persistedShowResults = _.cloneDeep(this.showResults);

              this.emptyRow = Object.assign({}, this.emptyShowResultRow(this.emptyRow, this.showResults));
              const input = document.querySelector('#srEmptyDogId') as HTMLElement | null;

              if (input != null) {
                  input.focus();
              }
            } else {
              //in case the dogId value has been changed we need to update the dog name to allow admin to validate data entry
              this.showResults[index].dogName = res.dogName;
              this.showResults[index].dogCallName = res.dogCallName;
              this.persistedShowResults = _.cloneDeep(this.showResults);
            }
            this.reloadData();
            this.errorMessage = null;
          }
        })
        .catch((error) => {
          this.errorMessage = getErrorMessage(error);
        })
        .finally(() => { this.$store.dispatch("changeLoaderStatus",false);});
    },
    deleteShowResult: function(item: any) {
      if(item.resultId) {//if that item has been persisted already
        this.deletedShowResultId = item.resultId;
        this.showDeleteConfirmationDialog = true;
      } else {
        const index = this.showResults.indexOf(item);
        this.showResults.splice(index, 1);
      }
    },
    confirmDelete: function() {
      this.errorMessage = null;
      showService.deleteShowResult(this.showId, this.deletedShowResultId)
      .then((res) => {
        if(!res.success){
          const index = this.showResults.map(sr => sr.resultId).indexOf(this.deletedShowResultId);
          this.errorMessage = getErrorMessage({ data: res });
          this.deletedShowResultId = null;
        } else {
          const index = this.showResults.map(sr => sr.resultId).indexOf(this.deletedShowResultId);
          this.showResults.splice(index, 1);
          this.persistedShowResults.splice(index, 1);
        }
      })
      .catch((error) => { this.errorMessage = getErrorMessage(error); })
      .finally(() => {this.showDeleteConfirmationDialog = false});
    },
    updateDates: function (val: any, key: string, item: any) {
      item[key] = val?.date;
      //workaround to force rerendering after setting up formatted date
      this.$set(this, 'showResults', this.showResults);
    },

    updateResultsHeight() {
      this.$nextTick(() => {
        const scroller = this.$refs.resultsScroller as Vue | undefined;
        const element = scroller?.$el as HTMLElement | undefined;
        if (element) {
          this.resultsHeight = Math.max(200, window.innerHeight - element.getBoundingClientRect().top - 48);
        }
      });
    },

    categoryItemsForRow(item: any) {

      const baseItems = this.showInfo.categories.filter((c: any) => c.id === "L" || c.id === "F");

      if (item.categoryId && !baseItems.some((c: any) => c.id === item.categoryId)) {
        const current = this.showInfo.categories.find((c: any) => c.id === item.categoryId);

        if (current) {
          return [current, ...baseItems];
        }

        return [{ id: item.categoryId, displayValue: item.categoryId }, ...baseItems];
      }
      return baseItems;
    }
  },
  created: function() {
    this.reloadData();
  },
  mounted: function() {
    window.addEventListener("resize", this.updateResultsHeight);
    this.updateResultsHeight();
  },
  beforeDestroy: function() {
    window.removeEventListener("resize", this.updateResultsHeight);
  },
  watch: {
    showId: function(newVal: String, oldVal: String) {
      if(newVal && newVal != oldVal){
        this.reloadData();
      }
    },
  },
  props: {
    showId: { type: String },
    showInfo: {type: Object}
  },
});
</script>

<style scoped>
.results-table {
  min-width: 1045px;
  width: 100%;
  margin-left: 0;
  margin-right: auto;
  text-align: left;
}
.results-container { overflow-x: auto; }
.results-scroll {
  min-width: 1045px;
  overflow-x: hidden;
  border-top: 1px solid rgba(0, 0, 0, 0.2);
}

.results-table th,
.results-table td { text-align: left; }

.results-grid-row {
  display: grid;
  grid-template-columns: 120px 145px 105px 75px 110px 200px 170px 55px 65px;
  width: 100%;
}
.results-grid-row > th,
.results-grid-row > td { min-width: 0; }
.results-header {
  align-items: end;
  padding-bottom: 6px;
}
.results-header > th { text-align: center; }
.entry-actions {
  grid-column: 8 / 10;
  align-self: center;
}
.results-table .score-column,
.score-column { text-align: center; }
.results-grid-row > td.score-column { align-self: center; }
.results-table .actions-column,
.actions-column { text-align: right; white-space: nowrap; }
.results-grid-row > td.actions-column { align-self: center; }
.action-buttons {
  display: grid;
  grid-template-columns: 24px 24px;
  gap: 4px;
  justify-content: end;
}
.dog-name-row {
  padding: 0 4px 16px;
  text-align: left;
  transform: translateY(-16px);
}
</style>
